import { create } from 'zustand';

interface CooldownEntry {
  startedAt: number; // performance.now() at arm
  durationMs: number;
  endsAt: number;
}

interface CooldownStore {
  cds: Record<number, CooldownEntry>;
  arm: (skillId: number, durationMs: number, now?: number) => void;
  clear: (skillId: number) => void;
}

export const useCooldownStore = create<CooldownStore>((set) => ({
  cds: {},
  arm: (skillId, durationMs, now = performance.now()) =>
    set((s) => ({
      cds: {
        ...s.cds,
        [skillId]: { startedAt: now, durationMs, endsAt: now + durationMs },
      },
    })),
  clear: (skillId) =>
    set((s) => {
      if (!(skillId in s.cds)) return s;
      const rest = { ...s.cds };
      delete rest[skillId];
      return { cds: rest };
    }),
}));
